module.exports = __webpack_public_path__ + "img/stars.4e42c0ea.svg";